import * as d3 from 'd3'

export default {

  methods: {

    link_Action() {
      
      // Remove
      this.canvasChart.remove()
      
      // Initial Data
      d3.select(`#TITLE_${this.localId}`).text(this.menus.list.find(f=> f.code == this.current.menu).title)
      this.init_dataSetValues()
      
      // Drawing
      this.draw_Chart()

      if(this.table.visible == 'Y') {
        this.draw_Header()
        this.draw_Table()
      }

    },

  } 
}